module.exports = __webpack_public_path__ + "static/media/blo1.2482d8b6.webp";